import { NodeSelection, Selection, TextSelection } from '@atlaskit/editor-prosemirror/state';
function isTaskListNode(node) {
  return Boolean(node && node.type && 'taskList' === node.type.name);
}
var resolvePositionToStartOfTaskItem = function resolvePositionToStartOfTaskItem($pos) {
  var fromRange = $pos.blockRange($pos, isTaskListNode);
  var fromPosition = fromRange && $pos.textOffset === 0 && fromRange.end - 1 === $pos.pos ? Selection.near($pos.doc.resolve(fromRange.end + 1), 1).$from : $pos;
  return fromPosition;
};
var resolvePositionToEndOfTaskItem = function resolvePositionToEndOfTaskItem($pos) {
  var toRange = $pos.blockRange($pos, isTaskListNode);
  var toPosition = toRange && $pos.textOffset === 0 && toRange.start + 1 === $pos.pos ? Selection.near($pos.doc.resolve(toRange.start - 1), -1).$to : $pos;
  return toPosition;
};
export var normalizeTaskItemsSelection = function normalizeTaskItemsSelection(selection) {
  if (selection.empty) {
    return selection;
  }
  var $from = selection.$from,
    $to = selection.$to;
  if (selection instanceof NodeSelection) {
    var _head = resolvePositionToStartOfTaskItem($from);
    return new TextSelection(_head, _head);
  }
  var head = resolvePositionToStartOfTaskItem($from);
  var anchor = resolvePositionToEndOfTaskItem($to);
  return new TextSelection(anchor, head);
};